import { DASHBOARD_SET_FILTER_DATE } from './constants'

export function setFilterDate(filterData) {
    return (dispatch) =>{
      dispatch({
        type: DASHBOARD_SET_FILTER_DATE,
        data: filterData
      })
  };
}

export function reducer(state, action) {
  if (action.type === DASHBOARD_SET_FILTER_DATE) {
    return {  
      ...state,  
      filterDate: {...state.filterDate, ...action.data }
    }
  } else {
    return state
  }
}